<template>
  <div class="bg1"  :style="backgroundDiv">
    <div class="br11">
      <div class="nr1">
        <div class="ernr1" style="display: inline">
          <el-row >
            <el-col :xs="{span:'0',offset:'0'}"  :sm="{span:'4',offset:'2'}" :md="{span:'4',offset:'4'}" :lg="{span:'4',offset:'0'}" :xl="{span:'4',offset:'0'}" >
            <img class="img1" :src="logSrc">
          </el-col>
            <el-col :xs="{span:'0',offset:'0'}" :sm="{span:'8',offset:'6'}" :md="{span:'10',offset:'5'}" :lg="{span:'8',offset:'1'}" :xl="{span:'8',offset:'1'}" >
              <ul v-if="language == 'CN'" class="list1">
                <li style="font-size: 18px; color: #FFFFFF;margin-top: 33px">联系我们</li>
                <li style="margin-top: 30px">公司电话：010-5629 3025</li>
                <li style="margin-top: 18px">公司传真：010-58256990</li>
                <li style="margin-top: 18px">业务沟通：tc@taocapital.cn</li>
                <li style="margin-top: 18px">办公地址：北京市东城区北三环东路36号 环球贸易中心B座2602-03</li>
              </ul>
              <ul v-if="language == 'EN'" class="list1">
                <li style="font-size: 18px; color: #FFFFFF;margin-top: 33px"> Contact us</li>
                <li style="margin-top: 30px">Company phone:010-5629 3025</li>
                <li style="margin-top: 18px">Company fax:010-58256990</li>
                <li style="margin-top: 18px">Business communication:tc@taocapital.cn</li>
                <li style="margin-top: 18px">Office Address:2602-03, Tower B, Global Trade Center, No. 36 North Third Ring East Road, Dongcheng District, Beijing</li>
              </ul>
            </el-col>
            <el-col :xs="{span:'0',offset:'0'}"  :sm="{span:'5',offset:'2'}" :md="{span:'4',offset:'3'}" :lg="{span:'7',offset:'0'}" :xl="{span:'7',offset:'0'}" >
              <ul class="list1">
                <li class="yitouTile"></li>
                <li style="margin-top: 30px"></li>
                <li style="margin-top: 18px"></li>
                <li style="margin-top: 18px"></li>
                <li style="margin-top: 18px"></li>
              </ul>
            </el-col>
            <el-col :xs="{span:'0',offset:'0'}" :sm="{span:'6',offset:'7'}" :md="{span:'10',offset:'7'}" :lg="{span:'3',offset:'0'}" :xl="{span:'3',offset:'0'}" >
              <img class="erweima" :src="erweima">
              <div class="erweimaText">扫一扫，关注公众号</div>
            </el-col>
            <el-col :xs="{span:'10',offset:'7'}"  :sm="{span:'0',offset:'0'}" :md="{span:'0',offset:'0'}" :lg="{span:'0',offset:'0'}" :xl="{span:'0',offset:'0'}" >
              <img class="img1" :src="logSrc">
            </el-col>
            <el-col :xs="{span:'22',offset:'2'}" :sm="{span:'0',offset:'0'}" :md="{span:'0',offset:'0'}" :lg="{span:'0',offset:'0'}" :xl="{span:'0',offset:'0'}" >
              <ul v-if="language == 'CN'" class="list1">
                <li style="font-size: 18px; color: #FFFFFF;margin-top: 40px">联系我们</li>
                <li style="margin-top: 30px">公司电话：010-5629 3025</li>
                <li style="margin-top: 18px">公司传真：010-58256990</li>
                <li style="margin-top: 18px">业务沟通：tc@taocapital.cn</li>
                <li style="margin-top: 18px;margin-bottom: 20px">办公地址：北京市东城区北三环东路36号 环球贸易中心B座2602-03</li>
              </ul>
              <ul v-if="language == 'EN'" class="list1">
                <li style="font-size: 18px; color: #FFFFFF;margin-top: 40px">Company phone:010-5629 3025</li>
                <li style="margin-top: 18px">Company fax:010-58256990</li>
                <li style="margin-top: 18px">Business communication:tc@taocapital.cn</li>
                <li style="margin-top: 18px;margin-bottom: 20px">Office Address:2602-03, Tower B, Global Trade Center, No. 36 North Third Ring East Road, Dongcheng District, Beijing</li>
              </ul>
            </el-col>
            <el-col style="margin-top: 10px" :xs="{span:'10',offset:'2'}" :sm="{span:'0',offset:'0'}" :md="{span:'0',offset:'0'}" :lg="{span:'0',offset:'0'}" :xl="{span:'0',offset:'0'}" >
              <img class="erweima" :src="erweima">
              <div class="erweimaText" >扫一扫，关注公众号</div>
            </el-col>


          </el-row>
        </div>
      </div>
    </div>
    <el-row >
    <div class="br21">
      <div class="bah1">京ICP备20014777号-1 道远资本管理(北京)有限公司</div>
    </div>
    </el-row>
  </div>
</template>

<script>
  import ElRow from "element-ui/packages/row/src/row";
  import ElCol from "element-ui/packages/col/src/col";

  export default {
    components: {
      ElCol,
      ElRow},
    name: "footer",
    data(){
      return{
        logSrc:require('@/assets/logB.png'),
        erweima:require('@/assets/home/erweima.jpg'),
        language:"EN",
        backgroundDiv: {
          backgroundImage:'url(' + require('@/assets/f.png') + ')',
          backgroundRepeat:'no-repeat',
          backgroundSize:'100% 100%'
        }
      }
    },
    mounted(){
    if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
    }
  }
</script>

<style>
  @media screen and (min-width: 750px) {

    .list1{
      list-style-type: none  ;
      width: 303px  ;
      left: 10px  ;
      margin-top: 33px  ;
      display: inline  ;
    }
    .img1{
      /*position: absolute  ;*/
      margin-top: 84px  ;
      display: block  ;
      width: 200px  ;
      height: 64px  ;
    }
  }

  @media screen and (max-width: 750px) {
    .list1{
      list-style-type: none  ;
      left: 10px  ;
      margin-top: 33px  ;
      display: inline  ;
    }


    .img1{
      /*position: absolute  ;*/
      margin-top: 40px  ;
      display: block  ;
      width: 100% ;
    }
    .list1 li{
      font-size:12px;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      text-align: left;
      color: #FFFFFF;
    }
    .erweimaText{
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin-top: 14px;
      margin-bottom: 20px;
    }
    .erweima{
      margin-top: 16px;
      display: block  ;
      width: 50px  ;
      height: 50px  ;

    }
    .yitouTile{
      font-size: 18px !important;
      color: #FFFFFF;
      margin-top: 40px
    }
    .bg1 {
      position: relative;
      width: 100%;

    }
    .br21{
      width: 100%  ;
      height: 20px  ;
    }
    .bah1{
      height: 20px;
      width:100% ;
      text-align: center;
      font-size:12px ;
      line-height: 20px;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      max-width: 750px;
      color:rgba(175,175,175,1);
    }
    .br11{
      position: relative  ;
      width: 100%  ;
      border-bottom: 2px solid #9094A0  ;
    }
  }


  @media screen and (max-width: 993px) and (min-width: 750px) {
    .list1 li{
      width: 303px;
      margin-left: 50px !important;
      display: inline-block;
      font-size:12px;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      text-align: left;
      color: #FFFFFF;
    }
    .erweimaText{
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin-top: 14px;
      margin-bottom: 20px;
    }
    .erweima{
      margin-top: 91px  ;
      display: block  ;
      width: 127px  ;
      height: 127px  ;

    }
    .yitouTile{
      font-size: 18px !important;
      color: #FFFFFF;
      margin-top: 72px
    }
    .bg1 {
      position: relative;
      width: 100%;
      height: 514px;
      min-width: 750px;
    }
    .br21{
      width: 100%  ;
      height: 20px  ;
      min-width: 750px;
    }
    .bah1{
      width:100% ;
      margin-top: 12px;
      text-align: center;
      font-size:14px ;
      line-height: 100%;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      max-width: 750px;
      color:rgba(175,175,175,1);
    }
    .br11{
      position: relative  ;
      width: 100%  ;
      height: 480px  ;
      min-width:750px  ;
      border-bottom: 2px solid #9094A0  ;
    }
    .bah1{
      width:100% ;
      margin-top: 12px;
      text-align: center;
      font-size:12px ;
      line-height: 100%;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      color:rgba(175,175,175,1);
    }
  }



  @media screen and (max-width: 1200px) and (min-width: 992px) {
    .list1 li{
      width: 303px;
      margin-left: 50px !important;
      display: inline-block;
      font-size:12px;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      text-align: left;
      color: #FFFFFF;
    }
    .erweimaText{
      font-size:14px;
      font-family:Microsoft YaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
      margin-top: 14px;
      margin-bottom: 20px;
    }
    .erweima{
      margin-top: 91px  ;
      display: block  ;
      width: 127px  ;
      height: 127px  ;
    }
    .yitouTile{
      font-size: 18px !important;
      color: #FFFFFF;
      margin-top: 72px
    }
    .bg1 {
      position: relative;
      width: 100%;
      height: 506px;
      min-width: 992px;
    }
    .br21{
      width: 100%  ;
      height: 0px  ;
      min-width:992px  ;
    }
    .bah1{
      width:100% ;
      margin-top: 12px;
      text-align: center;
      font-size:14px ;
      line-height: 100%;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      max-width: 992px;
      color:rgba(175,175,175,1);
    }
    .br11{
      position: relative  ;
      width: 100%  ;
      height: 474px  ;
      border-bottom: 2px solid #9094A0  ;
    }
    .bah1{
      width:100% ;
      margin-top: 12px;
      text-align: center;
      font-size:12px ;
      line-height: 100%;
      font-family:Adobe Heiti Std ;
      font-weight:normal;
      color:rgba(175,175,175,1);
    }
  }
  @media screen and (min-width: 1200px)  {
      .list1 li{
        width: 400px;
        margin-left: 50px !important;
        display: inline-block;
        font-size:12px;
        font-family:Adobe Heiti Std ;
        font-weight:normal;
        text-align: left;
        color: #FFFFFF;
      }
      .rowwidth{
        width: 100%;
      }
      .nr1{
        position: relative  ;
        margin: 0 auto  ;
        width: 100%;
        min-width: 1200px;
        max-width: 1210px;
        height: 276px  ;
      }
      .erweimaText{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(255,255,255,1);
        margin-top: 14px;
      }
      .erweima{
        /*position: absolute  ;*/
        margin-top: 52px  ;
        display: block  ;
        width: 127px  ;
        height: 127px  ;
      }
      .yitouTile{
        font-size: 18px !important;
        color: #FFFFFF;
        margin-top: 33px
      }
      .bg1{
        position: relative  ;
        width: 100%  ;
        height: 276px  ;
        min-width:1200px  ;
      }
      .br11{
        position: relative  ;
        width: 100%  ;
        height: 234px  ;
        min-width:1200px  ;
        border-bottom: 2px solid #9094A0  ;
      }
      .br21{
        width: 100%  ;
        height: 20px  ;
        min-width:1200px  ;
      }
      .bah1{
        width:100% ;
        margin-top: 12px;
        text-align: center;
        font-size:12px ;
        line-height: 100%;
        font-family:Adobe Heiti Std ;
        font-weight:normal;
        color:rgba(175,175,175,1);
      }
      .ernr1{
        margin: 0 auto  ;
        width: 1200px  ;
        height: 234px  ;
      }
  }
  /*.bg1{*/
    /*position: relative  ;*/
    /*width: 100%  ;*/
    /*height: 276px  ;*/
    /*min-width:1210px  ;*/

  /*}*/
  /*.nr1{*/
    /*position: relative  ;*/
    /*margin: 0 auto  ;*/
    /*width: 1210px  ;*/
    /*height: 276px  ;*/
  /*}*/
  /*.ernr1{*/
    /*margin: 0 auto  ;*/
    /*width: 1210px  ;*/
    /*height: 234px  ;*/
  /*}*/
  /*.img1{*/
    /*!*position: absolute  ;*!*/
    /*margin-top: 84px  ;*/
    /*display: block  ;*/
    /*width: 200px  ;*/
    /*height: 64px  ;*/
  /*}*/


  /*.list1 li{*/
     /*width: 303px;*/
     /*margin-left: 50px !important;*/
      /*display: inline-block;*/
     /*font-size:12px;*/
     /*font-family:Adobe Heiti Std ;*/
     /*font-weight:normal;*/
     /*text-align: left;*/
     /*color: #FFFFFF;*/
   /*}*/

</style>



// WEBPACK FOOTER //
// src/share/footer.vue